import { useMemo, useState } from "react";
import { ManufacturingLaborCompanyRates } from "./ManufacturingLaborCompanyRates";
import { ManufacturingLaborPayList } from "./ManufacturingLaborPayList";
import { ManufacturingLaborPayMatchInbox } from "./ManufacturingLaborPayMatchInbox";
import { ManufacturingTabbedSection } from "./ManufacturingTabbedSection";
import type { CompanyRateDraft } from "./useManufacturingLaborCompanyRates";

type CatalogPane = "unmatched" | "rates";

export function ManufacturingLaborPayView({
  plantId,
  navTick,
  enabled,
  readOnly = false,
}: {
  plantId: string;
  navTick: number;
  enabled: boolean;
  readOnly?: boolean;
}) {
  const [seed, setSeed] = useState<CompanyRateDraft | null>(null);
  const [rateTick, setRateTick] = useState(0);
  const [query, setQuery] = useState("");
  const [pane, setPane] = useState<CatalogPane>("unmatched");
  const search = useMemo(() => query.trim().toLowerCase(), [query]);
  const catalogTick = navTick + rateTick;

  return (
    <div className="grid items-start gap-4 lg:grid-cols-2">
      {plantId ? (
        <ManufacturingLaborPayList
          plantId={plantId}
          navTick={catalogTick}
          search={search}
          query={query}
          onQueryChange={setQuery}
          readOnly={readOnly}
        />
      ) : null}
      <ManufacturingTabbedSection
        className="min-w-0"
        tabs={[
          {
            id: "unmatched",
            label: "Unmatched order lines",
            description: readOnly
              ? "Orders whose options do not match a model or company labor rate."
              : "Orders whose options do not match a model or company labor rate. $0 IdeaRoom lines are included in the building or package. Add a rate and choose Pays by for priced lines.",
          },
          {
            id: "rates",
            label: "Company labor rates",
            description: readOnly
              ? "What the labor company is paid. Pays by is required."
              : "Pick a Models SKU, set the $ rate, and choose Pays by. Do not assume quantity 1.",
          },
        ]}
        activeTab={pane}
        onTabChange={setPane}
      >
        {pane === "unmatched" ? (
          <ManufacturingLaborPayMatchInbox
            plantId={plantId}
            navTick={catalogTick}
            search={search}
            readOnly={readOnly}
            embedded
            onAddRate={
              readOnly
                ? undefined
                : (draft) => {
                    setSeed(draft);
                    setPane("rates");
                  }
            }
          />
        ) : (
          <ManufacturingLaborCompanyRates
            enabled={enabled}
            navTick={catalogTick}
            search={search}
            readOnly={readOnly}
            embedded
            seed={readOnly ? null : seed}
            onSeedConsumed={() => setSeed(null)}
            onSaved={() => setRateTick((n) => n + 1)}
          />
        )}
      </ManufacturingTabbedSection>
    </div>
  );
}
